// extracted by mini-css-extract-plugin
module.exports = {"center":"AllAttendances__center--38FuG"};